import { useMemo } from "react";
import { zeroAddress } from "viem";

import { getContract } from "config/contracts";
import { uiFeeFactorKey } from "config/dataStore";
import { UI_FEE_RECEIVER_ACCOUNT } from "config/ui";
import { useMulticall } from "lib/multicall";
import { BN_ZERO } from "lib/numbers";
import { CONFIG_UPDATE_INTERVAL } from "lib/timeConstants";

export default function useUiFeeFactorRequest(chainId: number) {
  const account = UI_FEE_RECEIVER_ACCOUNT;
  const dataStore = getContract(chainId, "DataStore");

  // Skip request if fee receiver is not configured or DataStore is not deployed yet.
  const { data: uiFeeFactor, error } = useMulticall(chainId, "uiFeeFactorForAccount", {
    key: account && dataStore !== zeroAddress ? [account] : null,
    refreshInterval: CONFIG_UPDATE_INTERVAL,
    request: () => ({
      dataStore: {
        contractAddress: dataStore,
        abiId: "DataStore",
        calls: {
          keys: {
            methodName: "getUint",
            params: [uiFeeFactorKey(account!)],
          },
        },
      },
    }),
    parseResponse: (res) => {
      const raw = res?.data?.dataStore?.keys?.returnValues?.[0];
      try {
        return BigInt(raw ?? 0);
      } catch (_error) {
        return BN_ZERO;
      }
    },
  });

  return useMemo(
    () => ({
      uiFeeFactor: uiFeeFactor ?? BN_ZERO,
      error,
    }),
    [error, uiFeeFactor]
  );
}
